import React from 'react';
import { nextDirection } from '../../utils/tableSort';
import './SortableTh.css';
import { smartCaseNode } from '../../utils/smartCase';

/**
 * A list-table header cell that sorts its column.
 *
 * Shared by the six invoicing lists so the click cycle, the direction
 * indicator and the keyboard/screen-reader contract exist once
 * (invoice-list-column-sorting, 2026-08-20).
 *
 * Columns that carry no data — Actions — simply render a plain <th> by passing
 * sortable={false}: a sort control there would promise something it can't do.
 */
const ARROWS = { asc: '▲', desc: '▼' };

const SortableTh = ({ column, sort, onSort, sortable = true, children, ...rest }) => {
  const label = smartCaseNode(children ?? column?.label);

  if (!sortable || !column) {
    return <th {...rest}>{label}</th>;
  }

  const active = sort?.key === column.key ? sort.direction : null;

  return (
    <th
      {...rest}
      aria-sort={active === 'asc' ? 'ascending' : active === 'desc' ? 'descending' : 'none'}
      className={`sortable-th${active ? ' is-sorted' : ''}${rest.className ? ` ${rest.className}` : ''}`}
    >
      {/* The visible text is the column name; the control's PURPOSE is sorting,
          so that is what it is named for screen readers. */}
      <button
        type="button"
        className="sortable-th-button"
        onClick={() => onSort(column.key, active ? nextDirection(active) : 'asc')}
        aria-label={`Sort by ${smartCaseNode(column.label)}`}
        title={`Sort by ${smartCaseNode(column.label)}`}
      >
        <span className="sortable-th-label">{label}</span>
        <span className="sortable-th-arrow" aria-hidden="true">{ARROWS[active] || '⇅'}</span>
      </button>
    </th>
  );
};

export default SortableTh;
